/**
 * Financial institution IDs used for FI selector in header.
 */

export const FINANCIAL_INSTITUTION_IDS = {
  EXAGENS: "exagens",
  MSUFCU: "msufcu",
  LANGLEYFCU: "langleyfcu",
  FOURFRONTCU: "mi4frontcu",
} as const;

export type FinancialInstitutionId =
  (typeof FINANCIAL_INSTITUTION_IDS)[keyof typeof FINANCIAL_INSTITUTION_IDS];

/** Ordered list for iteration (e.g. header dropdown). */
export const FINANCIAL_INSTITUTION_IDS_LIST = [
  FINANCIAL_INSTITUTION_IDS.MSUFCU,
  FINANCIAL_INSTITUTION_IDS.LANGLEYFCU,
  FINANCIAL_INSTITUTION_IDS.FOURFRONTCU,
  FINANCIAL_INSTITUTION_IDS.EXAGENS,
] as const;
